import { Component, OnInit } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { PriceProviderService } from 'src/app/services/price-provider.service';
import calculateBaseOdds from 'src/app/utils/pity-odds-calculator';

Chart.register(...registerables);

@Component({
  selector: 'suit-piercing-root',
  templateUrl: './suit-piercing.component.html',
  styleUrls: ['../../shared-scss/default.scss'],
  standalone: false,
})
export class SuitPiercingComponent implements OnInit {
  constructor(
    private readonly gaService: GoogleAnalyticsService,
    readonly priceProvider: PriceProviderService
  ) {}
  ngOnInit(): void {
    this.SimulateUpgrading(false);
  }
  title = 'flyff-upgrade-calculator';

  simulationCount = 10000;

  gProsUsed: number[] = [0, 0, 0, 0];
  pd8Used: number[] = [0, 0, 0, 0];

  customUpgradeBonus = 0;
  getModifier() {
    let bonus = this.customUpgradeBonus;
    if (this.priceProvider.isFwc) {
      bonus += 100;
    }
    return 1 + bonus / 100;
  }
  isPd10 = false;
  isPiercingEvent = false;
  currentAttemptsIn = 0;
  currentPierce = 0;
  targetPierce = 4;

  baseOdds = [80, 50, 20, 5];
  basePiercingEventOdds = [84, 52.5, 22, 5.5];
  basePd10Odds = [88, 55, 24, 6];
  basePiercingEventPd10Odds = [92, 58, 26, 6.5];

  odds = this.baseOdds.map((x) => x * this.getModifier());
  piercingEventOdds = this.basePiercingEventOdds.map((x) => x * this.getModifier());
  pd10Odds = this.basePd10Odds.map((x) => x * this.getModifier());
  piercingEventPd10Odds = this.basePiercingEventPd10Odds.map((x) => x * this.getModifier());

  pityOdds = this.baseOdds.map((x) => calculateBaseOdds(x * this.getModifier()));
  pityOddsEvent = this.basePiercingEventOdds.map((x) => calculateBaseOdds(x * this.getModifier()));
  pityOddsPd10 = this.basePd10Odds.map((x) => calculateBaseOdds(x * this.getModifier()));
  pityOddsEventPd10 = this.basePiercingEventPd10Odds.map((x) =>
    calculateBaseOdds(x * this.getModifier())
  );

  myChart: Chart | undefined = undefined;

  GenerateChart() {
    if (this.myChart) {
      this.myChart.destroy();
    }

    const chartData: any = {
      labels: ['0 > 1', '1 > 2', '2 > 3', '3 > 4'],
      datasets: [
        {
          label: 'Attempts',
          data: this.gProsUsed.map((x) => x / this.simulationCount),
          borderWidth: 1,
        },
      ],
    };

    const config: any = {
      type: 'bar',
      data: chartData,
      options: {
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      },
    };

    const chartElem = <HTMLCanvasElement>(
      document.getElementById(`upgrade-data-chart`)
    );

    this.myChart = new Chart(chartElem, config);
  }

  SimulateUpgrading(isUserInput = true) {
    if (!this.verifyInput()) {
      return;
    }
    if (isUserInput) {
      this.gaService.event(
        'simulate_suit_pierce',
        'simulate',
        'Simulate suit piercing',
        this.simulationCount,
        true
      );
    }

    // Reset starter values
    this.gProsUsed = [0, 0, 0, 0, 0];
    this.pd8Used = [0, 0, 0, 0, 0];

    // Calculate modified odds with upgrade bonus
    this.odds = this.baseOdds.map((x) => x * this.getModifier());
    this.piercingEventOdds = this.basePiercingEventOdds.map((x) => x * this.getModifier());
    this.pd10Odds = this.basePd10Odds.map((x) => x * this.getModifier());
    this.piercingEventPd10Odds = this.basePiercingEventPd10Odds.map((x) => x * this.getModifier());

    this.pityOdds = this.baseOdds.map((x) => calculateBaseOdds(x * this.getModifier()));
    this.pityOddsEvent = this.basePiercingEventOdds.map((x) => calculateBaseOdds(x * this.getModifier()));
    this.pityOddsPd10 = this.basePd10Odds.map((x) => calculateBaseOdds(x * this.getModifier()));
    this.pityOddsEventPd10 = this.basePiercingEventPd10Odds.map((x) =>
      calculateBaseOdds(x * this.getModifier())
    );

    // Start upgrading
    for (let i = 0; i < this.simulationCount; i++) {
      let currentUpgrade = this.currentPierce;

      while (currentUpgrade < this.targetPierce) {
        let failedTries = 0;
        if (currentUpgrade === this.currentPierce) {
          failedTries = this.currentAttemptsIn;
        }
        let isSuccessful = false;
        while (!isSuccessful) {
          isSuccessful = this.SimulateSingleUpgrade(
            currentUpgrade,
            failedTries
          );
          if (!isSuccessful) {
            failedTries++;
          }
        }
        currentUpgrade++;
      }
    }

    this.GenerateChart();
  }

  verifyInput() {
    // clear all red inputs
    let isValid = true;
    if (this.currentPierce < 0 || this.currentPierce > 3) {
      // make input red
      isValid = false;
    }
    if (this.targetPierce < 1 || this.targetPierce > 4) {
      // make input red
      isValid = false;
    }
    if (this.currentAttemptsIn < 0) {
      // make input red
      isValid = false;
    }
    if (this.currentPierce >= this.targetPierce) {
      // make input red
      isValid = false;
    }
    if (this.priceProvider.gProPrice < 0) {
      // make input red
      isValid = false;
    }
    if (this.priceProvider.pd8Price < 0) {
      // make input red
      isValid = false;
    }
    return isValid;
  }

  addUpgradeTry(currentUpgrade: number) {
    this.gProsUsed[currentUpgrade]++;
    this.pd8Used[currentUpgrade]++;
  }

  SimulateSingleUpgrade(currentUpgrade: number, failedTries: number): boolean {
    this.addUpgradeTry(currentUpgrade);
    const random = Math.random() * 100;
    let odds = this.GetPiercingOdds()[currentUpgrade] * (failedTries + 1);

    if (random < odds) {
      return true;
    }
    return false;
  }

  GetGprosUsed(): number {
    return this.gProsUsed.reduce((a, b) => a + b, 0);
  }

  GetPd8Used(): number {
    return this.pd8Used.reduce((a, b) => a + b, 0);
  }

  GetTotalPenyaCost(): number {
    const totalXproCost = this.GetPd8Used() * this.priceProvider.gProPrice;
    const totalSunstoneCost = this.GetPd8Used() * this.priceProvider.pd8Price;
    return totalXproCost + totalSunstoneCost;
  }

  GetPiercingOdds(): number[] {
    const isPity = true;
    type OddsKey = 'default' | 'piercingEvent' | 'pd10' | 'piercingEventPd10';

    const baseOdds: Record<OddsKey, number[]> = {
      default: this.odds,
      piercingEvent: this.piercingEventOdds,
      pd10: this.pd10Odds,
      piercingEventPd10: this.piercingEventPd10Odds,
    };

    const pityOdds: Record<OddsKey, number[]> = {
      default: this.pityOdds,
      piercingEvent: this.pityOddsEvent,
      pd10: this.pityOddsPd10,
      piercingEventPd10: this.pityOddsEventPd10,
    };

    let key: OddsKey = 'default';
    if (this.isPd10 && this.isPiercingEvent) key = 'piercingEventPd10';
    else if (this.isPiercingEvent) key = 'piercingEvent';
    else if (this.isPd10) key = 'pd10';

    let odds;
    if (isPity) {
      odds = pityOdds[key];
    } else {
      odds = baseOdds[key];
    }
    return odds;
  }
}
